// test1199
(1199 && 0);
